import { api } from "@/lib/api";

const DB_NAME = "nota-harian-offline";
const STORE = "pending-uploads";
let flushing = false;

function notifyChange() {
  try { window.dispatchEvent(new Event("offline-queue-changed")); } catch (e) {}
}

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      if (!req.result.objectStoreNames.contains(STORE))
        req.result.createObjectStore(STORE, { keyPath: "id" });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function addPending(item) {
  const db = await openDB();
  await new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).put(item);
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
  notifyChange();
}

export async function getAllPending() {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readonly");
    const req = tx.objectStore(STORE).getAll();
    req.onsuccess = () => resolve(req.result || []);
    req.onerror = () => reject(req.error);
  });
}

export async function deletePending(id) {
  const db = await openDB();
  await new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).delete(id);
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
  notifyChange();
}

export async function countPending() {
  return (await getAllPending()).length;
}

// Uploads all queued items in order. Returns number successfully uploaded.
export async function flushPending() {
  if (flushing || !navigator.onLine) return 0;
  flushing = true;
  let ok = 0;
  try {
    const items = await getAllPending();
    for (const it of items) {
      try {
        const fd = new FormData();
        fd.append("outlet_id", it.outlet_id);
        (it.files || []).forEach((f) => fd.append("files", f));
        await api.post("/receipts", fd, { headers: { "Content-Type": "multipart/form-data" } });
        await deletePending(it.id);
        ok += 1;
      } catch (e) {
        // stop on first failure (likely still offline / server error); retry later
        break;
      }
    }
  } finally {
    flushing = false;
  }
  if (ok > 0) notifyChange();
  return ok;
}
